var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            title: "Điều khoản sử dụng",
            visible: _vm.isTermsOfUseDialog,
            width: "650px",
            "panel-icon": "el-icon-document",
            "panel-title": "XÁC NHẬN CHẤP THUẬN ĐIỀU KHOẢN BẢO MẬT",
            "panel-subtitle":
              "Quý Khách hàng vui lòng xác nhận sự đồng thuận về bảo vệ dữ liệu cá nhân theo Nghị định số 13/2023/NĐ-CP.",
            "confirm-text": "Có, tôi đồng ý",
            "cancel-text": "Không đồng ý",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isTermsOfUseDialog = $event
            },
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
            confirm: _vm.handleAgree,
          },
        },
        [
          _c("div", { staticClass: "dialog-inner-body" }, [
            _c("p", { staticClass: "paragraph-text" }, [
              _vm._v(
                "\n        Quý Khách hàng hiện đang sử dụng dịch vụ nhận thông báo biến động số dư tài khoản ngân hàng được tích hợp trong phần mềm\n        "
              ),
              _c("strong", [_vm._v("OneKids")]),
              _vm._v(", do đối tác trung gian của OneKids cung cấp.\n      "),
            ]),
            _c("p", { staticClass: "paragraph-text" }, [
              _vm._v("\n        Căn cứ quy định tại "),
              _c("strong", [_vm._v("Nghị định số 13/2023/NĐ-CP")]),
              _vm._v(
                " về bảo vệ dữ liệu cá nhân, nhằm đảm bảo việc tuân thủ quy định pháp luật liên quan đến bảo mật thông tin,\n        "
              ),
              _c("strong", [_vm._v("OneKids")]),
              _vm._v(
                " xin xác nhận sự đồng thuận từ Quý Khách hàng đối với các nội dung sau trước khi sử dụng dịch vụ, cụ thể:\n      "
              ),
            ]),
            _c("div", { staticClass: "terms-list-box mb-3" }, [
              _c("ol", { staticClass: "terms-ordered-list" }, [
                _c("li", [
                  _vm._v("\n            Tôi đồng ý cho phép "),
                  _c("strong", [_vm._v("OneKids")]),
                  _vm._v(
                    ", thông qua đối tác được ủy quyền, cung cấp và chia sẻ thông tin cần thiết với ngân hàng nơi tôi đang sử dụng tài khoản,\n            nhằm mục đích đăng ký và kích hoạt dịch vụ nhận thông báo biến động số dư.\n          "
                  ),
                ]),
                _c("li", [
                  _vm._v("\n            Tôi đồng ý cho phép "),
                  _c("strong", [_vm._v("OneKids")]),
                  _vm._v(
                    " và đối tác trung gian tiếp nhận dữ liệu giao dịch phát sinh từ tài khoản ngân hàng của tôi,\n            giới hạn trong phạm vi hiển thị thông tin trên phần mềm OneKids phục vụ mục đích quản lý thanh toán.\n          "
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "\n            Tôi xác nhận đã đọc, hiểu rõ và đồng ý để ngân hàng cung cấp thông tin liên quan đến trạng thái giao dịch của tài khoản cho đối tác trung gian và "
                  ),
                  _c("strong", [_vm._v("OneKids")]),
                  _vm._v(
                    ".\n            Đồng thời, tôi chấp thuận với \n            "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "terms-link",
                      attrs: {
                        href: "https://onekids.edu.vn/bdsd_dieu_khoan",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n              toàn bộ điều kiện và điều khoản sử dụng dịch vụ\n            "
                      ),
                    ]
                  ),
                  _vm._v(".\n          "),
                ]),
              ]),
            ]),
            _c("p", { staticClass: "warning-alert-text" }, [
              _vm._v(
                "\n        * Bằng việc nhấn vào nút “Có, tôi đồng ý” bên dưới, Quý Khách hàng xác nhận đã hiểu rõ, đồng ý và chấp thuận toàn bộ nội dung nêu trên.\n      "
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }